// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"vl-z","response":"wl-z","error":"xl-z","disabled":"yl-z","buttons":"zl-z","feedbackQuestionSection":"Al-z","yesNoWrapper":"Bl-z"};